import { lazy, PureComponent, Suspense } from 'react';

import { type RouteComponentProps } from 'react-router'

const IntegrationNetsuiteChunk = lazy(() =>
  import(
    /* webpackChunkName: 'IntegrationsNetsuiteView' */ '../containers/IntegrationNetsuiteView'
  ).then(({ IntegrationNetsuiteView }) => ({
    default: IntegrationNetsuiteView,
  }))
)

export class IntegrationNetsuitePage extends PureComponent<RouteComponentProps> {
  render() {
    return (
      <Suspense fallback={null}>
        <IntegrationNetsuiteChunk {...this.props} />
      </Suspense>
    );
  }
}
